// Case type options
export const CASE_TYPES = [
  'Minimal - Select fields',
  'Quick - Phone# only'
];

// Communication channel options
export const CHANNELS = ['SMS', 'VOICE'];

// Action type options
export const ACTION_TYPES = {
  CREATE_CASE: 'Create a test case',
  DEBUG_INFO: 'Get case debug info',
};

export const ACTION_TYPES_LIST = [
  ACTION_TYPES.CREATE_CASE,
  ACTION_TYPES.DEBUG_INFO,
];

// Initial form state
export const INITIAL_FORM_DATA = {
  apienv: '',
  plan: '',
  ctype: CASE_TYPES[0],
  channel: CHANNELS[1],
  patientExternalId: '',
  firstName: '',
  lastName: '',
  dob: '',
  gender: '',
  phoneNumber: '',
  postalCode: '',
  atype: '',
  caId: '',
};

// Debug info endpoint suffixes
export const DEBUG_ENDPOINTS = {
  case: '',
  patient: '/patient',
  provider: '/provider',
  organization: '/provider/organization',
  organizationGroup: '/provider/organization-group',
  outcomePlan: '/outcome-plan',
  taskGraphTemplates: '/outcome-plan/task-graph-templates',
  outcomePlanInstance: '/outcome-plan-instance',
  taskGraphInstances: '/outcome-plan-instance/task-graph-instances',
  nextExecutionTime: '/outcome-plan-instance/next-execution-time',
  executions: '/outcome-plan-instance/executions',
  schedulerStatus: '/outcome-plan-instance/scheduler/status',
  interactionRequests: '/outcome-plan-instance/interaction-requests',
  interactionResponses: '/outcome-plan-instance/interaction-responses',
};

// Gender options
export const GENDER_OPTIONS = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
  { value: 'other', label: 'Other' },
];
